import React from 'react';

import Loadable from 'react-loadable';
// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';

import { fg } from '@atlaskit/platform-feature-flags';

import type { ConversationAssistantProps } from './types';

const LazyWidget = lazyForPaint(
	() => import(/* webpackChunkName: "@atlassian/conversation-assistant-widget" */ './main'),
);

const LoadableWidget = Loadable({
	loader: () => import(/* webpackChunkName: "@atlassian/conversation-assistant-widget" */ './main'),
	loading: () => null,
});
export default function AsyncConversationAssistantWidget(
	props: ConversationAssistantProps,
): React.JSX.Element {
	if (fg('csm_conversation_assistant_widget_async_loading')) {
		return React.createElement(
			LazySuspense,
			{ fallback: null },
			React.createElement(LazyWidget, props),
		);
	}
	return React.createElement(LoadableWidget, props);
}
